import React, { useEffect, useState } from "react";
import { Link, withRouter, useParams } from "react-router-dom";
import { Envelope } from 'react-bootstrap-icons';
import { verifyEmail, sendVerificationEmail, isAuthenticate } from "../api/";
import successPng from "../assets/images/success.png";
import 'react-toastify/dist/ReactToastify.css';
import "../styles/verify.css";
import "../styles/landingpage.css";
import useToastify from "../hooks/useToastify";

export function EmailVerificationLandingPage(props) {
  return (
    <div className="container" data-testid="verify-landing" id="verify-landing">
      <div className="main landingpage">
        {props.isVerified ? (
          <React.Fragment>
            <div className="success-container">
              <Envelope className='mb-2' size={32} />
              <div className="text-verified" data-testid="verify-text">Your email is successfully verified.</div>
              <div className="img-verified">
                <img src={successPng} />
              </div>
            </div>
            <div className="btn-signin">
              <Link to={props.isAuth ? "/home" : "/login"}>
                <button>{props.isAuth ? "Home" : "Log In"}</button>
              </Link>
            </div>
          </React.Fragment>
        ) : (
          <div className="invalid-container">
            <Envelope className='mb-2' size={32} />
            <div className="text-invalid" data-testid="invalid-text">This is not a valid verification link.</div>
          </div>
        )}
      </div>
    </div>
  );
}

function InitEmailVerificationLanding({ onSendVerificationEmail, isAuth, newSignUp }) {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleClick = () => {
    setIsButtonDisabled(true); // Disable the button
    onSendVerificationEmail();
    // Enable the button after 1 minute (60,000 milliseconds)
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 60000);
  };
  
  return (
    <div className="container" data-testid="init-email-container">
      <div className="main landingpage">
        <div className="main-content" data-testid="init-email-link">
          <div className="text">
            <Envelope className='mb-2' size={32} />
            <span>Please check your email for the verification link.</span>
          </div>
        </div>
        <div className="btn-gotohome">
          <Link to={isAuth ? "/home" : "/login"}>
              <button>{isAuth ? "Home" : "Log In"}</button>
            </Link>
          </div>
        {!isButtonDisabled && !newSignUp && <div className="btn-resend">
          <button data-testid="resend" onClick={() => handleClick()}>Resend verification link</button>
        </div>}
      </div>
    </div>
  );
}

const Verify = (props) => {
  const { notifySuccess, notifyError } = useToastify();
  const [isAuth, setIsAuth] = useState(false);
  const params = new URLSearchParams(props.history.location.search);
  const sendverification = params.get("sendverification");
  const userIdFromQuery = params.get("uid");
  const newSignUp = params.get("new");

  const { uid: userId, token: verificationToken } = useParams();
  const [hasVerificationChecked, setHasVerificationChecked] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [invalidURI, setInvalidURI] = useState(false);

  const sendVerificationLink = () =>{
    sendVerificationEmail(userIdFromQuery).then((res) => {
      notifySuccess("Verification link sent successfully!")
    }).catch((error) => {
      notifyError("Something went wrong")
    });
  }

  useEffect(() => {
    document.title = "Email Verification";
    if (userId && verificationToken) {
      verifyEmail(userId, verificationToken)
        .then((res) => {
          setHasVerificationChecked(true);
          setIsVerified(res.success);
        })
        .catch((err) => {
          setHasVerificationChecked(true);
          setIsVerified(false);
        });
    }
    if (userIdFromQuery && sendverification) {
      sendVerificationLink();
    }
    if (!userIdFromQuery && !sendverification && !newSignUp) {
      setInvalidURI(true);
    }
    isAuthenticate()
      .then((res) => {
        if (res.success) setIsAuth(res.success);
      })
      .catch((err) => {
        setIsAuth(false);
      });
  }, []);

  if (props.initLanding) {
    if (invalidURI) return <EmailVerificationLandingPage isVerified={false} isAuth={false} />;
    return <>
      <InitEmailVerificationLanding onSendVerificationEmail={sendVerificationLink}  isAuth={isAuth} newSignUp={newSignUp} />
    </>;
  }
  if (hasVerificationChecked) return <EmailVerificationLandingPage isVerified={isVerified} isAuth={isAuth} />;
  return <div data-testid="empty-container"></div>;
};

export default withRouter(Verify);
